<template>
  <router-link to="/pet-vet-connection" class="pet-vet-promo" @click="trackClick">
    <img
      src="/images/pet-vet/pet-vet-hero.webp"
      alt=""
      loading="lazy"
    >
    <span class="pet-vet-promo__shade" aria-hidden="true"></span>
    <span class="pet-vet-promo__badge">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="m12 2.8 8 3v6.9c0 4.5-3.3 7.6-8 9-4.7-1.4-8-4.5-8-9V5.8l8-3Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
        <path d="m8.4 12.2 2.3 2.3 5-5.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Licensed veterinarians
    </span>
    <span class="pet-vet-promo__content">
      <span class="pet-vet-promo__eyebrow">Veterinary telehealth</span>
      <strong>A trusted place to start</strong>
      <span class="pet-vet-promo__description">Text or video guidance for pet health and behavior questions.</span>
      <span class="pet-vet-promo__action">
        <span><b>$9.99</b> / month</span>
        <span>Learn more <span aria-hidden="true">&rarr;</span></span>
      </span>
    </span>
  </router-link>
</template>

<script>
import { trackPromoClick } from '@/utils/activity';

export default {
  name: 'PetVetPromo',
  props: {
    source: {
      type: String,
      default: null,
      validator: value => ['test-kits', 'test-results'].includes(value),
    },
  },
  methods: {
    trackClick() {
      trackPromoClick('pet-vet', this.source);
    },
  },
};
</script>

<style scoped>
.pet-vet-promo {
  position: relative;
  display: block;
  width: 90%;
  min-height: 330px;
  margin-left: auto;
  overflow: hidden;
  border-radius: 20px;
  background: #07468d;
  box-shadow: 0 10px 24px rgba(15, 38, 95, 0.12);
  color: #fff !important;
  font-family: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
  text-decoration: none;
}

.pet-vet-promo img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 54% 50%;
  transition: transform 0.3s ease;
}

.pet-vet-promo__shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(7, 45, 87, 0.04) 12%, rgba(7, 45, 87, 0.96) 100%);
}

.pet-vet-promo__badge {
  position: absolute;
  top: 18px;
  left: 18px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.94);
  color: #07468d;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  box-shadow: 0 8px 20px rgba(15, 38, 95, 0.12);
}

.pet-vet-promo__badge svg {
  width: 18px;
  height: 18px;
}

.pet-vet-promo__content {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 25px;
}

.pet-vet-promo__eyebrow {
  color: #ffd3e6;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.pet-vet-promo strong {
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  line-height: 1.08;
}

.pet-vet-promo__description {
  color: #fff;
  font-size: 15px;
  line-height: 1.45;
}

.pet-vet-promo__action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 9px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.32);
  color: #fff;
  font-size: 14px;
  font-weight: 800;
}

.pet-vet-promo__action b {
  color: #fff;
  font-size: 17px;
}

.pet-vet-promo:hover,
.pet-vet-promo:focus {
  color: #fff !important;
  text-decoration: none;
}

.pet-vet-promo:hover img {
  transform: scale(1.025);
}

.pet-vet-promo:focus-visible {
  outline: 3px solid #f05798;
  outline-offset: 3px;
}

@media (max-width: 639px) {
  .pet-vet-promo {
    width: 100%;
    min-height: 300px;
    margin-left: 0;
    border-radius: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .pet-vet-promo img {
    transition: none;
  }
}
</style>
